import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MessageHeplerService } from '../../core/message-helper/message-helper.service';
import { MetadataService } from '../../core/meta-data/meta-data.service';
import { ScriptLoaderService } from '../../core/script-loader/script-loader.service';
import { ScriptName } from '../../shared/enum/script-name.enum';
declare const lottie: any;
@Component({
  selector: 'app-regret-page',
  templateUrl: './regret-page.component.html',
  styleUrls: ['./regret-page.component.scss']
})
export class RegretPageComponent implements OnInit, AfterViewInit {
  @ViewChild('lottieHolder') lottieHolderEL: ElementRef<HTMLDivElement>;
  srcUrlStr = '';

  constructor(private scriptLoader: ScriptLoaderService,
    private metadataService: MetadataService,
    messageService: MessageHeplerService) {
    messageService.closeNotification();
  }

  ngAfterViewInit() {
    this.scriptLoader.loadScript(ScriptName.LOTTIE_SCRIPT).subscribe(() => {
      this.load(this.srcUrlStr, this.lottieHolderEL.nativeElement);
    });
  }

  ngOnInit() {
    const path = true
      ? '../../assets/noContent/lf30_editor_nf62ie7f.json'
      : '../../../assets/noContent/lf30_editor_nf62ie7f.json';
    const srcUrl: URL = new URL(path, window.location.href);
    this.srcUrlStr = srcUrl.toString();
    this.metadataService.updateMetadata({
      title: 'No content',
      description: 'Shop not found',
      image: ''
    });
  }

  public load(srcData: any, lottieContainer: any): void {
    const options: any = {
      container: lottieContainer,
      loop: true,
      autoplay: true,
      renderer: 'svg',
      rendererSettings: {
        preserveAspectRatio: false,
        clearCanvas: false,
        progressiveLoad: true,
        hideOnTransparent: true,
      },
    };

    // Load the resource information
    try {
      const srcAttrib =
        typeof srcData === 'string' ? 'path' : 'animationData';
      // Initialize lottie player and load animation
      lottie.loadAnimation({
        ...options,
        [srcAttrib]: srcData
      });
    } catch (err) {

    }
  }


  /**
   * @name navigateShopHome
   * @description this method is used to navigate to the shop home page
   * @memberof RegretPageComponent
   */
  navigateShopHome() {
    window.location.href = environment.hybrisSfBasepath;
  }
}
